// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root_DNm7y{width:100%;border-bottom:1px solid #bbbcbc}.header_wHBVW{display:flex;justify-content:space-between;align-items:center;padding:20px 0;cursor:pointer}.header_wHBVW,.header_wHBVW h3{font-weight:400;font-size:14px;line-height:20px;margin-bottom:0}.iconWrapper_CV35R{flex-shrink:0;margin-left:10px}.icon_Zc-cM{transition:transform .15s ease-in-out}.icon_Zc-cM.open_OEgfz{transform:scaleY(-1)}.body_YDiI\\+{font-size:14px;font-weight:400;line-height:20px}.content_DR0HO{padding:5px 0 15px}", ""]);
// Exports
exports.locals = {
	"root": "root_DNm7y",
	"header": "header_wHBVW",
	"iconWrapper": "iconWrapper_CV35R",
	"icon": "icon_Zc-cM",
	"open": "open_OEgfz",
	"body": "body_YDiI+",
	"content": "content_DR0HO"
};
module.exports = exports;
